import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import 'remixicon/fonts/remixicon.css'

import App from './App.vue'
import router from './router'
import { i18n } from './utils/i18n'

// Import styles
import './assets/main.scss'
// Import GitHub Markdown CSS
import 'github-markdown-css/github-markdown-light.css'

const app = createApp(App)

// Pinia
const pinia = createPinia()
app.use(pinia)

// Router
app.use(router)

// Element Plus
const elementLocale = i18n.getLocale() === 'zh' ? zhCn : en
app.use(ElementPlus, { locale: elementLocale })

// Register Element Plus Icons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')